import React, { useState } from 'react';
import axios from 'axios';
import nectarLogo from '../assets/images/Nectar Infotel.png';

function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [selectedState, setSelectedState] = useState('UP'); // ✅ Naya State Variable
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const API_BASE_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:5002' 
  : window.location.origin;

            // ✅ Backend ko username, password aur stateName bhej rahe hain
            const res = await axios.post(`${API_BASE_URL}/api/login`, { 
                username, 
                password, 
                stateName: selectedState 
            });
            
            if (res.data.success) {
                // ✅ Local storage me user data ke sath selectedState bhi save kar rahe hain
                const userData = res.data;
                userData.stateName = selectedState;
                localStorage.setItem('user', JSON.stringify(userData));
                
                const role = res.data.role;

                setTimeout(() => {
                    if (role === 'super_admin' || role === 'district_admin' || role === 'state_admin') {
                        window.location.href = '/dashboard';
                    } else if (role === 'admin') {
                        window.location.href = '/admin';
                    } else if (role === 'checker') {
                        window.location.href = '/checker';
                    } else {
                        window.location.href = '/upload';
                    }
                }, 300); // Slight delay for smooth UI transition
            }
        } catch (err) {
            console.error("Login Error:", err);
            setError(err.response?.data?.message || 'Invalid Credentials! Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="nm-wrapper">
            
            {/* Header */}
            <header className="nm-header">
                <div className="nm-header-content">
                    <img src={nectarLogo} alt="Nectar Logo" style={{ height: '28px', width: 'auto' }} />
                    <span style={{ fontWeight: 800, fontSize: '1.125rem', color: '#0f172a', letterSpacing: '-0.025em' }}>
                        Nectar <span style={{ color: '#f97316', fontWeight: 500 }}>Infotel</span>
                    </span>
                </div>
            </header>

            {/* Main Container */}
            <main className="nm-main">
                
                {/* Title Section */}
                <div style={{ textAlign: 'center', marginBottom: '20px', animation: 'fadeIn 0.5s ease-out' }}>
                    <h1 className="nm-title">
                        Bulk <span className="nm-orange">Uploader</span>
                    </h1>
                    <p className="nm-subtitle">
                        Analyze data accuracy & upload bulk records seamlessly
                    </p>
                </div>

                {/* Auth Card */}
                <div className="nm-card">
                    <form onSubmit={handleLogin}>
                        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                            <h2 className="nm-card-title">Account Login</h2>
                            <p className="nm-card-subtitle">Access your data management portal</p>
                        </div>

                        {/* Error Alert */}
                        {error && (
                            <div className="nm-error">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: '16px', height: '16px'}}><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                                {error}
                            </div>
                        )}

                        {/* ✅ NAYA: State Selection Field */}
                        <div className="nm-input-group">
                            <label className="nm-label">Select State</label>
                            <div style={{ position: 'relative' }}>
                                <svg className="nm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                                <select 
                                    value={selectedState} 
                                    onChange={(e) => setSelectedState(e.target.value)}
                                    className="nm-input"
                                    disabled={loading}
                                    style={{ appearance: 'none', cursor: 'pointer' }}
                                >
                                    <option value="UP">Uttar Pradesh</option>
                                    <option value="ASSAM">Assam</option>
                                </select>
                                {/* Dropdown Arrow Icon */}
                                <svg style={{position: 'absolute', right: '14px', top: '16px', pointerEvents: 'none'}} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>
                            </div>
                        </div>

                        {/* Username Field */}
                        <div className="nm-input-group">
                            <label className="nm-label">Username / District Name</label>
                            <div style={{ position: 'relative' }}>
                                <svg className="nm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                <input
                                    type="text"
                                    required
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    className="nm-input"
                                    placeholder="Enter your username"
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        {/* Password Field */}
                        <div className="nm-input-group">
                            <label className="nm-label">Password</label>
                            <div style={{ position: 'relative' }}>
                                <svg className="nm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                                <input
                                    type="password"
                                    required
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="nm-input"
                                    placeholder="••••••••"
                                    disabled={loading}
                                />
                            </div>
                        </div>

                        {/* Submit Button */}
                        <button type="submit" disabled={loading} className="nm-btn">
                            {loading ? "AUTHENTICATING..." : "SECURE LOGIN"}
                            {!loading && (
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{width: '18px', height: '18px'}}><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                            )}
                        </button>

                    </form>
                </div>
            </main>

            {/* Footer */}
            <footer className="nm-footer">
                <p className="nm-footer-text">&copy; {new Date().getFullYear()} Nectar Infotel Solutions Pvt. Ltd.</p>
                <p className="nm-footer-sub" style={{marginBottom: '4px'}}>
                    Powered by <a href="https://nectarinfotel.com" target="_blank" rel="noopener noreferrer" className="nm-footer-link">Nectar Infotel</a>
                </p>
                <p style={{fontSize: '10px', color: '#94a3b8', letterSpacing: '1px', fontWeight: 'bold', margin: '0'}}>
                    SYSTEM VERSION 3.01.00
                </p>
            </footer>

            {/* Scoped Custom CSS to match the enterprise UI styling */}
            <style jsx="true">{`
                .nm-wrapper { min-height: 100vh; background-color: #f8fafc; display: flex; flex-direction: column; font-family: system-ui, -apple-system, sans-serif; overflow: hidden; }
                .nm-header { background: white; border-bottom: 1px solid #f1f5f9; height: 56px; display: flex; align-items: center; padding: 0 24px; }
                .nm-header-content { max-width: 1280px; margin: 0 auto; width: 100%; display: flex; align-items: center; gap: 12px; }
                .nm-main { flex-grow: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 16px; }
                .nm-title { font-size: 1.75rem; font-weight: 800; color: #0f172a; text-transform: uppercase; letter-spacing: 0.025em; text-align: center; margin-bottom: 4px; }
                .nm-orange { color: #f97316; }
                .nm-subtitle { font-size: 0.75rem; color: #64748b; font-weight: 500; text-transform: uppercase; letter-spacing: 0.025em; text-align: center; margin-bottom: 24px; }
                
                .nm-card { background: white; border-radius: 1rem; width: 100%; max-width: 420px; box-shadow: 0 8px 30px rgba(0,0,0,0.04); border: 1px solid #f1f5f9; padding: 32px; animation: fadeIn 0.3s ease-out; }
                .nm-card-title { font-size: 1.25rem; font-weight: 900; color: #0f172a; margin-bottom: 4px; }
                .nm-card-subtitle { font-size: 0.75rem; color: #64748b; font-weight: 500; margin: 0; }
                
                .nm-label { display: block; font-size: 0.625rem; font-weight: 800; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px; text-align: left; }
                .nm-input-group { position: relative; margin-bottom: 16px; }
                .nm-icon { position: absolute; left: 14px; top: 14px; width: 18px; height: 18px; color: #94a3b8; transition: color 0.2s; }
                .nm-input-group:focus-within .nm-icon { color: #f97316; }
                
                .nm-input { width: 100%; padding: 12px 16px 12px 42px; border: 1px solid #e2e8f0; border-radius: 0.75rem; outline: none; font-weight: 700; color: #1e293b; background: #f8fafc; transition: all 0.2s; font-size: 0.875rem; box-sizing: border-box; }
                .nm-input:focus { border-color: #f97316; background: white; box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.1); }
                .nm-input::placeholder { color: #94a3b8; font-weight: 500; }
                .nm-input:disabled { opacity: 0.7; cursor: not-allowed; }
                
                .nm-btn { width: 100%; background: linear-gradient(to right, #f97316, #ea580c); color: white; padding: 14px; border-radius: 0.75rem; border: none; font-weight: 900; font-size: 0.875rem; display: flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer; transition: all 0.2s; margin-top: 8px; box-shadow: 0 4px 6px -1px rgba(249, 115, 22, 0.2); }
                .nm-btn:hover:not(:disabled) { background: linear-gradient(to right, #ea580c, #c2410c); box-shadow: 0 10px 15px -3px rgba(249, 115, 22, 0.3); }
                .nm-btn:active:not(:disabled) { transform: scale(0.98); }
                .nm-btn:disabled { opacity: 0.6; cursor: not-allowed; }
                
                .nm-footer { padding: 16px; text-align: center; display: flex; flex-direction: column; gap: 4px; }
                .nm-footer-text { font-size: 0.625rem; color: #94a3b8; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; margin: 0; }
                .nm-footer-sub { font-size: 0.6875rem; color: #64748b; font-weight: 500; margin: 0; }
                .nm-footer-link { color: #f97316; text-decoration: none; font-weight: 700; transition: color 0.2s; }
                .nm-footer-link:hover { color: #c2410c; }
                
                .nm-error { background: #fef2f2; border: 1px solid #fee2e2; color: #ef4444; padding: 10px; border-radius: 0.5rem; font-size: 0.75rem; font-weight: 700; display: flex; align-items: center; justify-content: center; gap: 8px; margin-bottom: 20px; animation: shake 0.4s ease-in-out; }
                
                @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
                @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-4px); } 75% { transform: translateX(4px); } }

                @media (max-width: 640px) {
                    .nm-card { padding: 24px; border-radius: 1rem; border: none; box-shadow: 0 4px 20px rgba(0,0,0,0.05); }
                    .nm-title { font-size: 1.5rem; }
                    .nm-header { padding: 0 16px; }
                }
            `}</style>
        </div>
    );
}

export default LoginPage;
